import React, { useEffect, useState } from 'react';
import './CustomSelect.css'; // Import the CSS file for styling

const CustomSelect = ({ options, defaultSelected, onSelect, category, filterType }) => {

    const [selectedOption, setSelectedOption] = useState(defaultSelected);
    const [isDataset, setIsDataset] = useState(false);
    const [isOpen, setIsOpen] = useState(false);

    const toggleDropdown = () => {
        setIsOpen(!isOpen);
    };

    const handleOptionSelect = (option) => {
        setSelectedOption(option);
        setIsOpen(false);
        onSelect(option)
    };

    useEffect(() => {

        setIsDataset(true);

    }, [defaultSelected]);




    return (
        <>
            {
                isDataset === true ? (
                    <div className={`custom-select ${isOpen ? 'open' : ''}`}>
                        <div className="selected-option-drop" onClick={toggleDropdown}>
                            {
                                filterType == 'date' ? (<span className="selected-option-text">
                                    Sort By: {category === "type"
                                        ? (selectedOption?.label === "Date" ? "Date" : selectedOption?.label || "Date")
                                        : (selectedOption?.label === "Date" ? "Date" : selectedOption?.label || "Date")}
                                </span>) : (<span className="selected-option-text">
                                    Sort By : {category === "type"
                                        ? (selectedOption?.label === "All" ? "All" : selectedOption?.label || "All")
                                        : (selectedOption?.label === "All" ? "Brands" : selectedOption?.label || "Brands")}
                                </span>)
                            }



                            <span className={`icon ${isOpen ? 'up' : 'down'}`}>
                                <i className="bi bi-chevron-down" />
                            </span>
                        </div>
                        {isOpen && (
                            <div className="options-list custom-options-list">
                                {options.map(option => (
                                    <div
                                        key={option.value}
                                        className={`option custom-option ${selectedOption?.value === option.value ? 'selected' : ''}`}
                                        onClick={() => handleOptionSelect(option)}
                                    >
                                        <span className="option-label">{option?.label}</span>
                                    </div>
                                ))}
                            </div>
                        )}
                    </div >
                ) : (<></>)
            }
        </>

    );
};

export default CustomSelect;
